/* tslint:disable */
/* eslint-disable */
/**
 * MCP Manager API
 * API for managing Model Context Protocol (MCP) connections
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MCPToolFromJSON, MCPToolToJSON, } from './MCPTool';
/**
 * @export
 */
export const MCPServerWithToolsTypeEnum = {
    Sse: 'sse',
    Npx: 'npx',
    Uvx: 'uvx',
    Docker: 'docker'
};
/**
 * Check if a given object implements the MCPServerWithTools interface.
 */
export function instanceOfMCPServerWithTools(value) {
    if (!('server_id' in value) || value['server_id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('prompt' in value) || value['prompt'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('command' in value) || value['command'] === undefined)
        return false;
    if (!('tools' in value) || value['tools'] === undefined)
        return false;
    return true;
}
export function MCPServerWithToolsFromJSON(json) {
    return MCPServerWithToolsFromJSONTyped(json, false);
}
export function MCPServerWithToolsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'server_id': json['server_id'],
        'name': json['name'],
        'template_id': json['template_id'] == null ? undefined : json['template_id'],
        'prompt': json['prompt'],
        'type': json['type'],
        'command': json['command'],
        'tools': (json['tools'].map(MCPToolFromJSON)),
    };
}
export function MCPServerWithToolsToJSON(json) {
    return MCPServerWithToolsToJSONTyped(json, false);
}
export function MCPServerWithToolsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'server_id': value['server_id'],
        'name': value['name'],
        'template_id': value['template_id'],
        'prompt': value['prompt'],
        'type': value['type'],
        'command': value['command'],
        'tools': (value['tools'].map(MCPToolToJSON)),
    };
}
